module.exports = __webpack_public_path__ + "static/media/Logo_12weeks_fr.219f3946.svg";